module.exports = __webpack_public_path__ + "img/7fb9405b9bcc2306a7d98f4206c60abe.png";